/*eslint-disable*/
import React, { useState, useEffect, useContext } from 'react';
import './staffAugStatusMaster.scss';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import {
  getStaffingStatus,
  deleteStaffAugStatus,
  editStaffingStatus,
  editLostDroppedStatus,
  getLostDroppedStatus,
  deleteLostDroppedStatus,
  getGeography,
  deleteStaffGeographyMaster,
} from '../../Api/request/staffAugStatusMaster';
import AddIcon from '@mui/icons-material/Add';
import UseAxios from '../../Api/http/http';
import ButtonComponent from '../../Components/Button/button';
import {
  STAFF_AUG_STATUS_MASTER,
} from '../../Constants/strings';
import { AuthContext } from '../../Contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { MODULE_NAMES } from '../../Constants/modules';
import AddEditStaffAugStatusForm from './AddEditStaffAugStatusMaster/addEditStaffAugStatusMaster';
import DeleteDialog from './deleteStaffAugStatusMaster';
import SimpleSnackbar from '../../Components/Snackbar/snackbar.js';
import { ColorPicker } from '../../Components/ColorPicker/index.js';
import FormDialog from '../../Components/Modal/modal.js';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';
import ActionButtons from './actionButtons.js'; // Import the ActionButtons component
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

// eslint-disable-next-line max-lines-per-function
const StaffAugStatusMaster = () => {
  const [rows, setRows] = useState([]);
  const [statusCategory, setStatusCategory] = useState('');
  const [statusName, setStatusName] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [statusColor, setStatusColor] = useState('');
  const [isPickerVisible, setIsPickerVisible] = useState(false);
  const [isEnable, setIsEnable] = useState(false);
  const [enableDisableDialogOpen, setEnableDisableDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [currentPage, setCurrentPage] = useState(0); // Add state for current page
  const location = useLocation();
  const { userProfile } = useContext(AuthContext);
  const [updateColor, setUpdateColor] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const MODULE_PERMISSIONS = {
    'requirement-status': MODULE_NAMES.MASTER_STAFFAUG_REQUIREMENT_STATUS,
    'client-status': MODULE_NAMES.MASTER_STAFFAUG_CLIENT_INTERVIEW,
    'lost-dropped-status': MODULE_NAMES.MASTER_STAFFAUG_LOST_DROPPED_STATUS,
    'geography': MODULE_NAMES.MASTER_STAFFAUG_GEOGRAPHY,
  };
  
  // Function to get permissions based on subcategory
  const getPermission = (subCategory) => 
    userProfile?.permissions?.[MODULE_PERMISSIONS[subCategory]] || [];

  const permission = getPermission(statusCategory);

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    if (location.pathname === '/masters/requirement-status') {
      setStatusCategory('requirement-status');
    } 
    if (location.pathname === '/masters/client-interview-status') {
      setStatusCategory('client-status');
    }
    if (location.pathname === '/masters/lost-dropped-status') {
      setStatusCategory('lost-dropped-status');
    }
     if (location.pathname === '/masters/geography') {
      setStatusCategory('geography');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (statusCategory) {
      getStaffAugStatusData(currentPage); // Fetch data with the current page
    }
  }, [statusCategory, currentPage]); // Fetch data when category or current page changes
  const handleColorPick = (selectedColor) => {
    setStatusColor(selectedColor);
    setIsPickerVisible(false);
  };

  // eslint-disable-next-line no-unused-vars
 const getApiCall = () => {
  switch (statusCategory) {
    case 'lost-dropped-status':
      return UseAxios(getLostDroppedStatus());
    case 'geography':
      return UseAxios(getGeography());
    default:
      return UseAxios(getStaffingStatus(statusName, statusCategory));
  }
};

const getDataKey = () => {
  switch (statusCategory) {
    case 'lost-dropped-status':
      return 'lostDroppedStatusDetails';
    case 'geography':
      return 'geographyDetails';
    default:
      return 'staffingStatusDetails';
  }
};

const mapResponseData = (data) => {
  if (!data) return [];
  if (statusCategory === 'geography') {
    return data.map(({ id, geographyType, geographyPlace, isMapped = false }) => ({
      id,
      statusName: geographyType,
      statusDescription: geographyPlace,
      isMapped,
    }));
  }

  return data.map((item) => ({
    ...item,
    id: item.id,
  }));
};

const getStaffAugStatusData = (_page = currentPage) => {
  setIsLoading(true);
  getApiCall()
    .then((response) => {
      const dataKey = getDataKey();
      const rawData = response.data[dataKey];
      const mappedData = mapResponseData(rawData);
      setRows(mappedData);
      setStatusName('');
      setIsLoading(false);
    })
    .catch(() => {
      setRows([]);
      setIsLoading(false);
    });
};

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, [location, statusCategory]);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
    setIsLaptopView(window.innerWidth >= 1024 && window.innerWidth <= 1200);
  };

  const handleSwitchChange = (status) => {
    setSelectedStatus(status);
    setIsEnable(!status.isActive);
    setDialogTitle(!status.isActive ? 'Enable Status' : 'Disable Status');
    setEnableDisableDialogOpen(true);
  };

  const handleConfirmEnableDisable = async () => {
    try {
      const updatedStatus = { ...selectedStatus, statusId: selectedStatus?.id, isActive: isEnable };
      const config =
        statusCategory === 'lost-dropped-status'
          ? editLostDroppedStatus(updatedStatus)
          : editStaffingStatus(updatedStatus);
      const response = await UseAxios(config);
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === updatedStatus.id ? { ...row, isActive: updatedStatus.isActive } : row,
        ),
      );
      setEnableDisableDialogOpen(false);
      snackbarOpen(`Status has been ${isEnable ? 'enabled' : 'disabled'}`);
    } catch (error) {
      console.error('Failed to update status:', error);
      snackbarOpen('Failed to update status, please try again', 'error');
    }
  };

  const handleCloseEnableDisableDialog = () => {
    setEnableDisableDialogOpen(false);
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
  };

  const handleResponse = (response, val) => {
    switch (response.status || response.data.status) {
    case 200:
      snackbarOpen(response.data.message, 'success');
      setRows((prevRows) => prevRows.filter((row) => row.id !== val.id));
      break;
    case 400:
      snackbarOpen(response.data.response.data.message, 'warning', 10000);
      break;
    case 404:
      snackbarOpen(response.data.response.data.message, 'warning', 10000);
      break;
    case 401:
      snackbarOpen(AUTHENTICATION_FAILED, 'warning');
      break;
    default:
      snackbarOpen(OOPS_TRY_AGAIN, 'warning');
      break;
    }
  };

  const getDeletePayload = (item, userProfile, statusCategory) => {
  switch (statusCategory) {
    case 'geography':
      return {
        geographyId: item.id,
        lastUpdatedBy: userProfile?.user_name,
      };
    case 'lost-dropped-status':
      return {
        statusId: item.id,
        lastUpdatedBy: userProfile?.user_name,
      };
    default:
      return {
        statusId: item.id,
        statusCategory: item.statusCategory,
        lastUpdatedBy: userProfile?.user_name,
      };
    }
  };

  const handleDeleteAction = async (item) => {
  const payload = getDeletePayload(item, userProfile, statusCategory);


  try {
     let config;
    if (statusCategory === 'geography') {
      config = deleteStaffGeographyMaster(payload);
    } else if (statusCategory === 'lost-dropped-status') {
      config = deleteLostDroppedStatus(payload.statusId);
    } else {
      config = deleteStaffAugStatus(payload.statusId, payload.statusCategory);
    }
    const response = await UseAxios(config);
    handleResponse(response, item);
  } catch (error) {
    snackbarOpen(STAFF_AUG_STATUS_MASTER.OOPS_TRY_AGAIN, 'warning');
  } finally {
    handleCloseDialog();
  }
};

  const handleCloseDialog = () => {
    setSelectedItem(null);
  };

  const snackbarOpen = (message, severityVariable, defaultTime = 4000) => {
    setSnackbarMessage(message);
    setSeverity(severityVariable);
    setOpenSnackbar(true);
    setTimeout(() => setOpenSnackbar(false), defaultTime);
  };

  const handleEditStaffAugStatusClick = (status) => {
    if (status.isMapped) {
      snackbarOpen('Edit unable! The status is mapped at staff augmentation module.', 'warning');
    }
    setSelectedStatus(status);
    setStatusColor(status.statusColor);
    setUpdateColor(status.statusColor);
    setIsEdit(true);
    setModalOpen(true);
  };

  const handleAddStaffAugStatusClick = () => {
    setSelectedStatus(null);
    setStatusColor('');
    setUpdateColor('');
    setIsEdit(false);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setIsEdit(false);
  };

  const getColumnWidth = (mobile, laptop, defaultWidth) => {
    if (isMobileView) {
      return mobile;
    } else if (isLaptopView) {
      return laptop;
    }
    return defaultWidth;
  };

  const getColumnFlex = (defaultFlex) => {
    if (!isMobileView && !isLaptopView) {
      return defaultFlex;
    }
    return undefined;
  };

  const columns =
  statusCategory === 'geography'
    ? [
        {
          field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.STATUS_NAME,
          headerName: 'Deal type',
          width: getColumnWidth(200, 200, 120),
          flex: getColumnFlex(1.5),
          sortable: false,
          disableColumnMenu: true,
        },
        {
          field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.DESCRIPTION,
          headerName: 'Geography',
          width: getColumnWidth(490, 490, 180),
          flex: getColumnFlex(1.5),
          sortable: false,
          disableColumnMenu: true,
        },
      ]
    : [
        {
          field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.STATUS_NAME,
          headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.STATUS_NAME,
          width: getColumnWidth(200, 200, 120),
          flex: getColumnFlex(0.7),
          sortable: false,
          disableColumnMenu: true,
        },
        ...(statusCategory === 'lost-dropped-status'
          ? [
              {
                field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.REASON,
                headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.REASON,
                width: getColumnWidth(200, 200, 120),
                flex: getColumnFlex(1.3),
                sortable: false,
                disableColumnMenu: true,
              },
            ]
          : []),
        {
          field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.DESCRIPTION,
          headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.DESCRIPTION,
          width: getColumnWidth(490, 490, 180),
          flex: getColumnFlex(1.5),
          sortable: false,
          disableColumnMenu: true,
        },
        {
          field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.COLOR,
          headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.COLOR,
          width: getColumnWidth(200, 200, 290),
          flex: getColumnFlex(0.7),
          sortable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <div className="staff-status-color-cell-container">
              <div
                className="staff-status-color-box"
                style={{ backgroundColor: params.value }}
              />
            </div>
          ),
        },
      ].filter(
        (column) =>
          !(
            statusCategory === 'lost-dropped-status' &&
            column.field === STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.COLOR
          )
      );


  const mobileColumns = [];
  const desktopColumns = [];

  if (isLaptopView || isMobileView) {
    mobileColumns.push(...columns);
    mobileColumns.push({
      field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.IS_ACTIVE,
      headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.IS_ACTIVE,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: getColumnWidth(160, 220, 220),
      flex: getColumnFlex(0.7),
      renderCell: (params) => (
        <div
    className={`mobile-action-icons ${
      statusCategory === 'geography' ? 'geography-actions' : ''
    }`}
  >
          <ActionButtons
            params={params}
            hasAccess={hasAccess}
            {...(statusCategory !== 'geography' ? { handleSwitchChange } : {})}
            handleEditStaffAugStatusClick={handleEditStaffAugStatusClick}
            handleDeleteClick={handleDeleteClick}
          />
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    });
  } else {
    desktopColumns.push(...columns);
    desktopColumns.push(
      {
        field: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.IS_ACTIVE,
        headerName: STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_HEADERNAME.IS_ACTIVE,
        flex: 0.7,
        renderCell: (params) => (
           <div className={statusCategory === 'geography' ? 'geography-actions' : ''}>
          <ActionButtons
            params={params}
            hasAccess={hasAccess}
            {...(statusCategory !== 'geography' ? { handleSwitchChange } : {})}
            handleEditStaffAugStatusClick={handleEditStaffAugStatusClick}
            handleDeleteClick={handleDeleteClick}
          />
          </div>  
        ),
        sortable: false,
        disableColumnMenu: true,
      },
    );
  }

  const sortFilterColumns = columns
    .filter((column) => column.field !== STAFF_AUG_STATUS_MASTER.STAFF_STATUS_MASTER_FIELD.COLOR)
    .map((column) => column.field);
  // Extract existing status names from the rows
  const existingStatusNames = rows.map(row => row.statusName);
  const existingColors = rows.map(row => row.statusColor);
  const existingReasons = rows.map(row => row.reason)

  const getStatusTitle = () => {
    if (statusCategory === 'client-status') {
      return STAFF_AUG_STATUS_MASTER.CLIENT_STATUS_TITLE;
    } else if (statusCategory === 'lost-dropped-status') {
      return STAFF_AUG_STATUS_MASTER.LOST_DROPPED;
    } else if (statusCategory === 'geography') {
      return STAFF_AUG_STATUS_MASTER.GEOGRAPHY;
    }else {
      return STAFF_AUG_STATUS_MASTER.REQUIREMENT_STATUS_TITLE;
    }
  };

  return (
    <div className="staff-aug-status-outer-layer">
      <div className="staff-aug-status-master">
        <div className="staff-aug-status-title">
          {getStatusTitle()}
        </div>
        <div className="staff-aug-status-create-button">
          <div>
            <ButtonComponent
              disabled={!hasAccess('create')}
              id="add-staff-aug-status-btn"
              label={
                statusCategory === 'geography'
                  ? STAFF_AUG_STATUS_MASTER.ADD_GEOGRAPHY
                  : STAFF_AUG_STATUS_MASTER.NEW_STATUS
              }
              variant="contained"
              onClick={handleAddStaffAugStatusClick}
              startIcon={<AddIcon />}
              btnCss={
                !hasAccess('create')
                  ? 'add-staff-aug-status-btn-disabled'
                  : 'add-staff-aug-status-btn'
              }
            />
          </div>
        </div>
        <div className="staff-status-data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : (
            <DataGridComponent
              dataRows={rows}
              dataColumns={
                isMobileView || isLaptopView ? mobileColumns : desktopColumns
              }
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isEdit={isEdit}
              isFilteredRows={rows}
              onPageChange={(params) => setCurrentPage(params.page)} // Track current page
              page={currentPage} // Set current page
            />
          )}
        </div>
      </div>
      <AddEditStaffAugStatusForm
        modalOpen={modalOpen}
        handleClose={handleCloseModal}
        setRows={setRows}
        isEditMode={isEdit}
        statusId={selectedStatus?.id || null}
        initialStatusName={selectedStatus?.statusName || ''}
        initialDescription={selectedStatus?.statusDescription || ''}
        initialColor={updateColor || ''}
        lastUpdatedBy={userProfile?.user_name}
        isActive={selectedStatus?.isActive || false}
        statusCategory={statusCategory}
        getStaffAugStatusData={getStaffAugStatusData}
        setIsPickerVisible={setIsPickerVisible}
        isPickerVisible={isPickerVisible}
        selectedStatusColor={statusColor}
        existingStatusNames={existingStatusNames} // Pass existingStatusNames prop
        existingColors={existingColors} // Pass existingColors prop
        existingReasons={existingReasons}
        isMapped={selectedStatus?.isMapped}
        initialReason={selectedStatus?.reason || ''} 
      />

      <ColorPicker // Color picker component to show color picker
        isPickerVisible={isPickerVisible}
        setIsPickerVisible={setIsPickerVisible}
        handlePickColor={handleColorPick}
        pickedColor={statusColor} // Pass pickedColor prop
      />
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={`staff-aug-status-snackbar ${severity}`}
      />
      <DeleteDialog
        handleCloseAction={handleCloseDialog}
        selectedItem={selectedItem}
        handleDeleteAction={handleDeleteAction}
        setRows={setRows}
        handleSnackbar={snackbarOpen}
        statusCategory={statusCategory}
      />
      <FormDialog
        title={dialogTitle}
        open={enableDisableDialogOpen}
        handleClose={handleCloseEnableDisableDialog}
        button1Action={handleCloseEnableDisableDialog}
        button2Action={handleConfirmEnableDisable}
        width={360}
        height={205}
        dialogCss=""
        dialogPaperCss=""
        dialogBodycontent={
          <div className="dialog-body-text">
            <div className="dialog-alert-icon">
              <img className="icon-image" src={alertIcon} alt="" />
            </div>
            <div className="dialog-message-text">
              {`Are you sure you want to ${!selectedStatus?.isActive ? 'enable' : 'disable'} this status?`}
            </div>
          </div>
        }
        button1="Cancel"
        button2={isEnable ? 'Enable' : 'Disable'}
        cancelButtonId="cancel-enable-disable-btn"
        submitButtonId="confirm-enable-disable-btn"
        button2Disabled={false}
        isPopUp={false}
        isSessionPopup={false}
      />
    </div>
  );
};

export default StaffAugStatusMaster;
